export enum ContestStatusEnum {
  ACTIVE = 1,
}

export const contestStatusNames: Map<ContestStatusEnum, string> = new Map([
  [ContestStatusEnum.ACTIVE, 'Active']
]);


